/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react'
import { Card } from 'primereact/card'
import { Form } from 'reactstrap'
import back from '../assets/images/back.svg'
import excel from '../assets/images/excel.svg'
import { useHistory } from 'react-router-dom'
import { Button } from 'primereact/button'
import { FileUpload } from 'primereact/fileupload'
import { fileUploadConstants } from '../_constants'
import { Growl } from 'primereact/growl'
import { CSVLink } from 'react-csv'
import { Paginator } from 'primereact/paginator'
import { Dialog } from 'primereact/dialog'
import { messageConstants } from '../_constants'
import { authConstants } from '../_constants'
import { uuidv4 } from '../_common/utils'


// eslint-disable-next-line react/prop-types
export default function BulkUploadComponent({ getFileUploadLogs, clearFileLog, fileUploadLog, fileUploadLogCount, deleteFileLogById, fileLogDeleteResponse }) {
  const history = useHistory()
  const growl = useRef()
  const redirectBackToPreviousPage = () => {
    history.goBack()
  }
  const [savedCount, setSavedCount] = useState(0)
  const [showResult, setShowResult] = useState(false)
  const [failedData, setFaildedData] = useState([])
  const [templateData] = useState([{ name: null, ticker: null, sectorName: null }])
  const [isDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false)
  const [first, setFirst] = useState(0)
  const [fileName, setFileName] = useState('')
  const [page, setPage] = useState(0)
  const [showLoader, setShowLoader] = useState(false)
  const [pageSize] = useState(5)
  const [deleteRow, setDeleteRow] = useState(false)
  const [updateCount, setUpdateCount] = useState(0)
  const [failedCount, setFailedCount] = useState(0)
  const [duplicateCount, setDuplicateCount] = useState(0)

  const headers = [
    { label: 'COMPANY NAME', key: 'name' },
    { label: 'TICKER', key: 'ticker' },
    { label: 'SECTOR', key: 'sectorName' },
    { label: 'INDUSTRY', key: 'industryName' },
    { label: 'EXCHANGE', key: 'exchangeName' },
    { label: 'MARKET CAPITALIZATION', key: 'marketCapitalization' },
    { label: 'EXCHANGE COUNTRY', key: 'exchangeCountry' },
    { label: 'EARNINGS YIELD', key: 'earningsYeild' },
    { label: 'BARRIERS', key: 'barriers' },
    { label: 'FINANCIAL STRENGTH', key: 'financialStrength' },
    { label: 'MOMENTUM', key: 'momentum' },
    { label: 'GROWTH TYPE', key: 'growthType' },
    { label: 'TOP NEW BUYS', key: 'topNewsBuy' },
    { label: 'DIVIDEND LEADER', key: 'dividendLeader' },
    { label: 'SOCIALLY RESPONSIBLE', key: 'sociallyResponsible' },
    { label: 'WATCH LIST', key: 'watchlist' },
    { label: 'INTERSECTION', key: 'intersection' },
    { label: 'UNDER VALUED', key: 'underValued' },
  ]

  useEffect(() => {
    setShowLoader(true)
    getFileUploadLogs(page, pageSize)
    // eslint-disable-next-line
  }, [getFileUploadLogs, setShowLoader, pageSize])

  useEffect(() => {
    setShowLoader(false)
  }, [fileUploadLog])

  useEffect(() => {
    setShowLoader(false)
    if (fileLogDeleteResponse && fileLogDeleteResponse === 'success') {
      growl.current.show({ severity: messageConstants.sevirity.success, summary: '', detail: messageConstants.bulkUpload.deletedSuccess })
      getFileUploadLogs(page, pageSize)
      clearFileLog()
    }
    else if (fileLogDeleteResponse) {
      clearFileLog()
      growl.current.show({ severity: messageConstants.sevirity.error, summary: '', detail: fileLogDeleteResponse })

    }
    // eslint-disable-next-line
  }, [fileLogDeleteResponse, clearFileLog, getFileUploadLogs]
  )
  const showDeleteDialog = (event, rowData) => {
    setDeleteRow(rowData)
    setIsDeleteDialogVisible(true)
  }
  const deleteFileLog = () => {
    deleteFileLogById(deleteRow.logId)
    setIsDeleteDialogVisible(false)
    setShowLoader(true)
  }
  const onUpload = (event) => {
    setShowLoader(false)
    const result = JSON.parse(event.xhr.response)
    if (result.data) {
      const failed = result.data['FAILED'][Object.keys(result.data['FAILED'])[0]]
      setFaildedData(failed)
      setShowResult(true)
      setSavedCount(Object.keys(result.data['SAVED']))
      setUpdateCount(Object.keys(result.data['UPDATED']))
      setDuplicateCount(Object.keys(result.data['DUPLICATE']))
      setFailedCount(Object.keys(result.data['FAILED']))
      setFileName(event.files[0].name.substring(0, event.files[0].name.lastIndexOf('.')))
      getFileUploadLogs()
      if (savedCount > 0 && updateCount > 0) {
        growl.current.show({ severity: messageConstants.sevirity.success, summary: '', detail: messageConstants.bulkUpload.success })
      }
    } else {
      growl.current.show({ severity: messageConstants.sevirity.error, summary: '', detail: result.message })
    }
  }
  const onBeforeSend = () => {
    setShowLoader(true)
    setShowResult(false)
  }
  const onValidationFail = () => {
    growl.current.show({ severity: messageConstants.sevirity.error, summary: '', detail: messageConstants.bulkUpload.fileUploadSizeMessage })
  }
  const onError = () => {
    setShowLoader(false)
    growl.current.show({ severity: messageConstants.sevirity.error, summary: '', detail: messageConstants.bulkUpload.failed })
  }
  const onPageChange = (event) => {
    setFirst(event.first)
    setPage(event.page)
    setShowLoader(true)
    getFileUploadLogs(event.page, pageSize)
  }
  const footer = (
    <div>
      <Button label={messageConstants.bulkUpload.ok} icon="pi pi-check" onClick={() => deleteFileLog()} />
      <Button label={messageConstants.bulkUpload.cancel} className="p-button-raised p-button-secondary" icon="pi pi-times" onClick={() => setIsDeleteDialogVisible(false)} />
    </div>
  )
  const timeRead = (timeStamp) => {
    return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(timeStamp)
  }
  const getRowCols = () => {
    return (
      <>
        {fileUploadLog?.map(uploadLog => (
          <div className="uploadTable--mainarea" key={uploadLog.logId}>
            <div className="w-40">
              <p>{uploadLog.fileName}</p>
            </div>
            <div className="w-25">
              <p>{uploadLog.type}</p>
            </div>
            <div className="w-25">
              <p>{timeRead(uploadLog.createdOn)}</p>
            </div>
            <div className="w-10">
              <div className="flex">
                <i className="pi pi-trash m-r-5 pointer" title="Delete" onClick={(event) => showDeleteDialog(event, uploadLog)}></i>
              </div>
            </div>
          </div>
        ))}
      </>
    )
  }


  return (
    <div className="p-col-10 dashboard">
      <div className="dashboard--wrapper uploadView">
        <Card className="cardBase addSector">
          <Form >
            <div className="p-grid">
              <div className="p-col-12 uploadView--titleBetween">
                <div className="uploadView--uploadTitle">
                  <img src={back} alt={back} className="m-r-10 pointer" onClick={() => redirectBackToPreviousPage()} />
                  <h4 className="display_1 m-b-0"> Bulk Upload</h4>
                </div>

                <CSVLink data={templateData} className="btn btn-primary uploadView--templateDownload" headers={headers} filename={messageConstants.bulkUpload.sampleTemplate}>
                  <Button icon="pi pi-download" className="addBtnCustom pointer-none" /> Download Template
                </CSVLink>
              </div>
              <div className="p-col-12">
                <div className="uploadView--viewBox customFileUpload">
                  <img src={excel} alt={excel} />
                  <FileUpload name="file" onValidationFail={onValidationFail} onError={onError} onBeforeSend={onBeforeSend} onUpload={onUpload} accept={messageConstants.bulkUpload.fileAcceptFormat} url={fileUploadConstants.DATA_UPLOAD_URL + '/' + localStorage.getItem(authConstants.USERID) + '/' + uuidv4()} maxFileSize={5000000} auto={true} multiple={false} />
                </div>
              </div>
              <div className="p-col-12 m-t-10 m-b-8 divTextCenter">
                {showResult &&
                  <div>
                    <div className="m-b-10 green-bg">Added :  {savedCount}</div>
                    <div className="m-b-10 yellow-bg">Updated : {updateCount}
                      {/* {(updatedData.length>0) && <CSVLink className="m-l-10 handsymbol" data={updatedData} headers={headers} filename={fileName+messageConstants.bulkUpload.updatedTitle}>
                      Download
                    </CSVLink>} */}
                    </div>
                    <div className="m-b-10 red-bg">Failed : {failedCount}
                      {(failedData.length > 0) && <CSVLink className="m-l-10 handsymbol" data={failedData} headers={headers} filename={fileName + messageConstants.bulkUpload.failedTitle}>
                        Download
                    </CSVLink>}
                    </div>
                    <div className="m-b-10">Duplicate : {duplicateCount}
                      {/* {(duplicateData.length>0) && <CSVLink className="m-l-10 handsymbol" data={duplicateData} headers={headers} filename={fileName+messageConstants.bulkUpload.duplicateTitle}>
                      Download
                    </CSVLink>} */}
                    </div>
                  </div>
                }
              </div>
            </div>
          </Form>
        </Card>

        <Card className="cardBase addSector m-t-20">
          <Form >
            <div className="p-grid">
              <div className="p-col-12 titleSec">
                <h4 className="display_1 m-b-0"> FILE UPLOAD LOG</h4>
              </div>
              <div className="p-col-12">
                <div className="uploadTable">
                  <div className="uploadTable--header">
                    <div className="w-40">
                      <h5>FILE NAME</h5>
                    </div>
                    <div className="w-25">
                      <h5>TYPE</h5>
                    </div>
                    <div className="w-25">
                      <h5>UPLOADED ON</h5>
                    </div>
                    <div className="w-10">
                      <h5>ACTION</h5>
                    </div>
                  </div>

                  {getRowCols()}
                </div>
                {fileUploadLog?.length === 0 && <div className="text-center" >No Records Found</div>}
                {fileUploadLog?.length > 0 && <div className="p-col-12 p-0">
                  <Paginator first={first} rows={pageSize} scrollable={true} responsive={true} totalRecords={fileUploadLogCount} onPageChange={onPageChange}></Paginator>

                </div>}
              </div>
            </div>
          </Form>
        </Card>
      </div>
      <Dialog header={messageConstants.bulkUpload.deleteDialogTitle} footer={footer} visible={isDeleteDialogVisible} style={{ width: '50vw' }} modal={true} onHide={() => setIsDeleteDialogVisible(false)}>
        <div>{messageConstants.bulkUpload.deleteDialogMessage}</div>
      </Dialog>
      <Growl ref={growl} />
      {showLoader && <div className="overlay">
        <div className="lds-ripple"><div></div><div></div></div>
      </div>}
    </div>
  )
}

